import {
  CREATE_LEAD_CANDIDATE_REQUEST,
  CREATE_LEAD_CANDIDATE_SUCCESS,
  CREATE_LEAD_CANDIDATE_FAILURE,
  FETCH_LEAD_CANDIDATE_DETAILS_REQUEST,
  FETCH_LEAD_CANDIDATE_DETAILS_SUCCESS,
  FETCH_LEAD_CANDIDATE_DETAILS_FAILURE,
  RESET_LEAD_STATE,
  LeadState,
  LeadActionTypes,
} from "../types/leadTypes";

// Initial State
const initialState: LeadState = {
  loading: false,
  success: false,
  error: null,
  leadData: null,
  leadCandidateDetails: null,
  fetchingDetails: false,
  fetchDetailsError: null,
};

// Lead Reducer
const leadReducer = (
  state: LeadState = initialState,
  action: LeadActionTypes
): LeadState => {
  switch (action.type) {
    case CREATE_LEAD_CANDIDATE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case CREATE_LEAD_CANDIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        leadData: action.payload,
      };

    case CREATE_LEAD_CANDIDATE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        leadData: null,
      };

    case FETCH_LEAD_CANDIDATE_DETAILS_REQUEST:
      return {
        ...state,
        fetchingDetails: true,
        fetchDetailsError: null,
      };

    case FETCH_LEAD_CANDIDATE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingDetails: false,
        fetchDetailsError: null,
        leadCandidateDetails: action.payload,
      };

    case FETCH_LEAD_CANDIDATE_DETAILS_FAILURE:
      return {
        ...state,
        fetchingDetails: false,
        fetchDetailsError: action.payload,
        leadCandidateDetails: null,
      };

    case RESET_LEAD_STATE:
      return initialState;

    default:
      return state;
  }
};

export default leadReducer;

